<template>
	<div class="search-wrapper">
		<div class="common-header">
			<mt-button class="back" slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			<div class="common-search">
				<input type="text" :placeholder="$t('SearchPlaceholder')" v-model="orderkeyword">
			</div>
			<div class="search_btn" @click="goOrderSearch(orderkeyword)">{{ $t('Search') }}</div>
		</div>
		<div class="search-body">

			<div class="list current-search" v-if='currenKeywords.length > 0'>
				<div class="list-header">
					<span>{{ $t('Recent searches') }}</span>
					<img src="../../../assets/image/home/home-search-delete1.png" v-on:click='deleteCurrent()'>
				</div>
				<ul>
					<li class="item" v-for="(item, index) in currenKeywords" v-on:click='getKey(item)' :key="index">
						{{ item }}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { searchKeywordList } from '../../../api/homesearch'
import { Toast } from 'mint-ui'
export default {
	data() {
		return {
			currenKeywords: [],
			orderkeyword: ''
		}
	},
	computed: {
		...mapState({
			currentKey: state => state.homesearch.currentKey
		})
	},

	created() {
		this.getCurrentKey()
	},

	methods: {
		...mapMutations({
			'changeKey': 'changeKey'
		}),
		goOrderSearch(value) {
			if (value.replace(/\s+/g, '').length <= 0) {
				Toast(this.$t('Please search'))
				return false
			} else {
				this.orderkeyword = value
			}
			if (value) {
				this.currenKeywords.push(value)
				let data = this.utils.arrayFilter(this.currenKeywords)
				this.utils.save('orderkeyword', data)
			}
			this.$router.push({
				name: 'MemberOrderList',
				query: { keyword: this.orderkeyword }
			})
		},
		getKey(item) {
			if (item.content) {
				this.orderkeyword = item.content
			} else {
				this.orderkeyword = item
			}
			this.changeKey(this.orderkeyword)
			this.goOrderSearch(this.orderkeyword)
		},

		deleteCurrent() {
			this.utils.save('orderkeyword', [])
			this.currenKeywords = this.utils.fetch('orderkeyword')
		},

		getCurrentKey() {
			this.currenKeywords = this.utils.fetch('orderkeyword')
		}
	}
}
</script>

<style lang='scss' scoped>
.search-wrapper {
	height: auto;
	width: auto;
	background-color: #fff;

	.common-header {
		display: flex;
		align-items: center;
		height: 2rem;
		padding: .1rem 0;

		.back {
			background-color: #fff;
			box-shadow: none;
		}

		.common-search {
			padding: 0;
			padding-left: $pageSpace;
			padding-right: $pageSpace;
			flex: 1;

			input {
				box-sizing: border-box;
				width: 100%;
				height: 1.6rem;
				border-radius: 1.6rem;
				background: #F4F4F4 url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
				background-size: 0.55rem;
				font-size: $fontSize;
				color: #999;
				padding-left: 1.6rem;
				border: 0;
			}
		}

		.search_btn {
			background-color: $primaryColor;
			padding: .3rem .7rem;
			color: #fff;
			border-radius: 1.2rem;
			font-size: .7rem;
			margin-right: .6rem;
		}
	}

	.search-body {
		padding: 0.75rem;

		div.list {
			margin-bottom: 1.5rem;

			.list-header {
				display: flex;
				justify-content: space-between;
				align-content: center;
				align-items: center;

				span {
					color: #333;
					font-size: 0.7rem;
					background: url('../../../assets/image/home/home-search-history.png') no-repeat left center;
					background-size: 0.8rem;
					padding-left: 1.25rem;
					align-self: flex-end;
				}

				img {
					width: 1.2rem;
					height: 1.2rem;
					cursor: pointer;
				}
			}

			ul {
				display: flex;
				padding-top: 0.65rem;
				flex-wrap: wrap;

				li {
					padding: 0.4rem;
					background-color: #f4f4f4;
					color: #333;
					font-size: 0.6rem;
					margin-right: 0.8rem;
					margin-bottom: 0.8rem;
					cursor: pointer;
					border-radius: .2rem;
				}
			}
		}

		div.hot-wrapper {
			.list-header {
				span {
					background: url('../../../assets/image/home/home-search-hot.png') no-repeat left center;
					background-size: 0.8rem;
				}
			}
		}
	}
}
</style>
